import { render, staticRenderFns } from "./JobsAllocatedInAMonthPPMJobsCompleted.vue?vue&type=template&id=89ed78e6&"
import script from "./JobsAllocatedInAMonthPPMJobsCompleted.vue?vue&type=script&lang=ts&"
export * from "./JobsAllocatedInAMonthPPMJobsCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports